import { rcdataToBitmap } from "./rcdataToBitmap";

// Бюджет считаем в пикселях, а не в штуках: аватар и скриншот различаются по размеру в десятки раз
const cacheBudgetPixels = 8_000_000;

// Порядок вставки в Map используется как порядок вытеснения: самые давние картинки уходят первыми
const decodedBitmaps = new Map<string, ImageBitmap>();
const pendingBitmaps = new Map<string, Promise<ImageBitmap>>();
let cachedPixels = 0;

const getPixelsCount = (bitmap: ImageBitmap) => bitmap.width * bitmap.height;

const evictOverBudget = (keptRcdata: string) => {
  for (const [rcdata, bitmap] of decodedBitmaps) {
    if (cachedPixels <= cacheBudgetPixels) return;
    if (rcdata === keptRcdata) continue;

    decodedBitmaps.delete(rcdata);
    cachedPixels -= getPixelsCount(bitmap);
    bitmap.close();
  }
};

/** Уже декодированная картинка: позволяет нарисовать ее синхронно, без пустого кадра. */
export const getCachedBitmap = (rcdata: string) => {
  const bitmap = decodedBitmaps.get(rcdata);
  if (!bitmap) return undefined;

  // Обновляем «свежесть» записи
  decodedBitmaps.delete(rcdata);
  decodedBitmaps.set(rcdata, bitmap);
  return bitmap;
};

/**
 * Декодирует RCDATA один раз для всех потребителей: одна и та же картинка (например, аватар группы у каждого
 * сообщения) раньше декодировалась заново в каждой строке и при каждом ее повторном монтировании.
 * Владелец битмапа - кэш: вызывающий код не должен вызывать close().
 */
export const loadBitmap = (rcdata: string): Promise<ImageBitmap> => {
  const cachedBitmap = getCachedBitmap(rcdata);
  if (cachedBitmap) return Promise.resolve(cachedBitmap);

  const pendingBitmap = pendingBitmaps.get(rcdata);
  if (pendingBitmap) return pendingBitmap;

  const request = rcdataToBitmap(rcdata).then(
    (bitmap) => {
      pendingBitmaps.delete(rcdata);
      decodedBitmaps.set(rcdata, bitmap);
      cachedPixels += getPixelsCount(bitmap);
      evictOverBudget(rcdata);
      return bitmap;
    },
    (error: unknown) => {
      pendingBitmaps.delete(rcdata);
      throw error;
    },
  );
  pendingBitmaps.set(rcdata, request);

  return request;
};
